import React from "react";
import { ManageContentTopicsContent } from "../components/CMS/Topics/ManageContentTopicsContent";
import { ToastContainer } from "react-toastify";

export const ContentTopics = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageContentTopicsContent />
        </div>
      </div>
    </div>
  );
};
